import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError, timer } from 'rxjs'
import { mergeMap, retryWhen } from 'rxjs/operators'
import { appConfig } from '../../../brands/_current/config/app-config'

@Injectable()
export class HttpReplayInterceptor implements HttpInterceptor {
  private readonly maxReplayAttempts: number

  constructor() {
    this.maxReplayAttempts = appConfig.core.xhrRetryAttempts
  }

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      retryWhen((error$: Observable<HttpErrorResponse>) =>
        error$.pipe(
          mergeMap((error, i) => {
            const retryAttempt = i + 1
            if (retryAttempt > this.maxReplayAttempts) {
              console.warn(`Superato il numero massimo di tentativi (${this.maxReplayAttempts}). Non ritento.`)
              return throwError(() => error)
            }
            if (error.status !== 0) {
              console.warn(`Lo status era "${error.status}" e non "0". Non ritento.`)
              return throwError(() => error)
            }
            const delay = retryAttempt * retryAttempt * 500
            console.warn(
              `Ritento la chiamata fallita tra ${delay} ms. Tentativo ${retryAttempt}/${this.maxReplayAttempts}`,
            )
            return timer(delay)
          }),
        ),
      ),
    )
  }
}
